/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getAllSchools, getEnrolledStudents, getRoomsfilter } from '@/app/services/CompanyReports/companyReports';
import * as Actions from '@/app/store/actions';
import { generateAgeString } from '@/utils/utils';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from 'react-router-dom';
import './companyReport.css';

export default function EnrolledStudent() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const enrolledStudentRef = useRef(null);
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		name: '',
		school_id: '',
		room_id: '',
		status: '',
		date_from: '',
		date_to: '',
	});

	const [rooms, setRooms] = useState([]);
	const [schools, setSchools] = useState([]);
	const [allSchoolPage, setAllSchoolPage] = useState(1);
	const date = new Date();
	const [roomPage, setRoomPage] = useState(1);
	const [isLoadingExport, setIsLoadingExport] = useState(false);

	useEffect(() => {
		let isMounted = true;
		getRoomsfilter(roomPage, filters?.school_id == 'All' ? '' : filters?.school_id)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		return () => {
			isMounted = false;
		};
	}, [roomPage, filters?.school_id, dispatch]);

	useEffect(() => {
		let isMounted = true;
		getAllSchools('', '', '', allSchoolPage, '')
			.then((res) => {
				if (!isMounted) return;
				setSchools([...schools, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setAllSchoolPage(allSchoolPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get schools.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		return () => {
			isMounted = false;
		};
	}, [allSchoolPage, dispatch]);

	const handleLoadMore = () => {
		setFetchingMore(true);
		getEnrolledStudents(
			0,
			filters.name,
			filters.school_id === 'All' ? '' : filters.school_id,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.status,
			filters.date_from,
			filters.date_to,
			page,
		)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch((err) => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const handleExport = () => {
		setIsLoadingExport(true);
		getEnrolledStudents(
			1,
			filters.name,
			filters.school_id === 'All' ? '' : filters.school_id,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.status,
			filters.date_from,
			filters.date_to,
		)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `StudentEnrollment_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				setIsLoadingExport(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
				setIsLoadingExport(false);
			})
			.finally(() => {
				setIsLoadingExport(false);
			});
	};

	const ApplyFilters = () => {
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		const timeout = setTimeout(
			() => {
				getEnrolledStudents(
					0,
					filters.name,
					filters.school_id === 'All' ? '' : filters.school_id,
					filters.room_id === 'All' ? '' : filters.room_id,
					filters.status,
					filters.date_from,
					filters.date_to,
					1,
				)
					.then((res) => {
						setFirstLoad(false);
						setRows(res.data.data);
						if (res.data.last_page > res.data.current_page) {
							setHasMore(true);
						} else {
							setHasMore(false);
						}
						setPage(res.data.current_page + 1);
						dispatch(
							Actions.showMessage({
								message: 'Report has been generated',
								variant: 'success',
							}),
						);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							}),
						);
					})
					.finally(() => {
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000,
		);
		setPage(1);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handlePrint = useReactToPrint({
		content: () => enrolledStudentRef.current,
	});

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		if (name === 'school_id') {
			setRooms([]);
			setRoomPage(1);
		}
		setFilters({ ...filters, [name]: value });
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto enrolled-cont">
				<div className="flex items-center justify-between">
					<div className="reports-topDiv">
						<h1 className="">
							<span className="">
								<IconButton
									onClick={() => {
										navigate(-1);
									}}
								>
									<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>
							<span className="text-pd-xl self-end font-bold mr-28">Enrolled Students</span>
						</h1>
						<p>Detailed data of Enrolled student information</p>
					</div>
					<div className="flex justify-between">
						<div className="flex items-center justify-between">
							<div className="">
								<span>
									{!isLoadingExport ? (
										<a>
											<CustomButton
												height="40px"
												marginRight="17px"
												onClick={handleExport}
												variant="primary"
												width="100px"
											>
												<span className="mr-4">
													<FontAwesomeIcon icon={faDownload} />
												</span>
												Export
											</CustomButton>
										</a>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
										<i aria-hidden="true" className="fa fa-print" /> Print
									</CustomButton>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<TextField
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													id="search-icon"
													onClick={() => {
														document.getElementById('search-input').focus();
													}}
												>
													<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
												</IconButton>
											</InputAdornment>
										),
									}}
									className="mr-10"
									id="search-input"
									label="Search by Student"
									name="name"
									onChange={handleFilters}
									style={{ width: 155 }}
									value={filters.name}
								/>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="school_id">School</InputLabel>
									<Select
										endAdornment={
											filters.school_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																school_id: '',
															});
															setRooms([]);
															setRoomPage(1);
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="school_id"
										label="School"
										labelId="school_id"
										name="school_id"
										onChange={handleFilters}
										style={{ width: 120 }}
										value={filters.school_id}
									>
										<MenuItem value="All">All</MenuItem>
										{schools.length ? (
											schools.map((school) => {
												return (
													<MenuItem id={school?.id} key={school?.id} value={school?.id}>
														<div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{school?.name}</div>
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="roomLabel">Room</InputLabel>
									<Select
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={handleFilters}
										style={{ width: 120 }}
										value={filters.room_id}
									>
										<MenuItem value="All">All</MenuItem>
										{rooms.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room.id}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="status">Status</InputLabel>
									<Select
										endAdornment={
											filters.status ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																status: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="status"
										label="Status"
										labelId="status"
										name="status"
										onChange={handleFilters}
										style={{ width: 120 }}
										value={filters.status}
									>
										<MenuItem value="1">Active</MenuItem>
										<MenuItem value="0">Inactive</MenuItem>
									</Select>
								</FormControl>
							</div>
							<div className="mx-10 student-date-field" style={{ width: 125 }}>
								<CustomDatePicker
									disableFuture
									id="date-from"
									label="Date From"
									maxDate={filters.date_to || undefined}
									setValue={(Date) => {
										setFilters({ ...filters, date_from: Date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.date_from}
								/>
							</div>
							<div className="mr-20 ml-10 student-date-field" style={{ width: 125 }}>
								<CustomDatePicker
									disableFuture
									id="date-to"
									label="Date To"
									minDate={filters.date_from || undefined}
									setValue={(Date) => {
										setFilters({ ...filters, date_to: Date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.date_to}
								/>
							</div>
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={
											!filters.name && !filters.school_id && !filters.room_id && !filters.status && !filters.date_from
												? !filters.date_to
												: null
										}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="student-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={enrolledStudentRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography variant="subtitle1">
										<span style={{ display: 'block', marginBottom: '-0.7em', writingMode: '' }}>
											642 Glan Eagles Street
										</span>{' '}
										<span>Hom Lake, Orlando, FL 38637</span>
									</Typography>
									<Typography variant="subtitle1">+1 365 986 1258</Typography>
									<Typography variant="subtitle1">perfectday@gmail.com</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment(date).format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Enrolled Students</h1>
							</div>

							<Table className="enrolledtudent-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Student
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Parent
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
											School Name
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
											Contact Info
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '10%' }}>
											Status
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
											Enrollment Date And Time
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : !rows.length && !firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No Student Record
											</TableCell>
										</TableRow>
									) : (
										rows?.map((row) => {
											return (
												<TableRow key={row?.id}>
													<TableCell>
														<div className="flex">
															<Avatar className="mr-6" src={row?.thumb} />
															<div className="flex-col items-start">
																<div className="student-homeroom break-word">{row?.home_room?.name}</div>
																<div className="student-name break-word">
																	{row?.first_name} {row?.last_name}
																</div>
																<div className="student-age-font " style={{ width: '90px' }}>
																	{generateAgeString(row.date_of_birth)}
																</div>
															</div>
														</div>
													</TableCell>
													<TableCell>
														<div className="flex items-center parent-column">
															<Avatar className="mr-6" src={row?.contacts[0]?.thumb} />
															<div className="flex-col">
																<div className="parent-name break-word">
																	{row?.contacts[0]?.first_name} {row?.contacts[0]?.last_name}
																</div>
																<div className="parent-relation">{row?.contacts[0]?.relation_with_child}</div>
															</div>
														</div>
													</TableCell>
													<TableCell>
														<div className="items-center school-name-std">{row?.school?.name}</div>
													</TableCell>
													<TableCell>
														<div className="flex-col">
															<div className="contact-email break-word">
																{row?.contacts[0]?.email}
															</div>
															<div className="contact-phone">
																{row?.contacts[0]?.phone}
															</div>
														</div>
													</TableCell>
													<TableCell>
														<div className={row.status ? 'active-label' : 'disable-label'}>
															{row.status ? 'Active' : 'Inactive'}
														</div>
													</TableCell>
													<TableCell>
														<div className="flex-col">
															<div className="enroll-date">{moment.utc(row?.created_at).local().format('L')}</div>
															<div className="student-enroll-date">
																{moment.utc(row?.created_at).local().format('LT')}
															</div>
														</div>
													</TableCell>
												</TableRow>
											);
										})
									)}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="enrolledtudent-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
									Student
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
									Parent
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
									School Name
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
									Contact Info
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
									Status
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '17%' }}>
									Enrollment Date And Time
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Record Found
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => {
									return (
										<TableRow key={row?.id}>
											<TableCell>
												<div className="flex">
													<Avatar className="mr-6" src={row?.thumb} />
													<div className="flex-col items-start">
														<div className="student-homeroom break-word">{row?.home_room?.name}</div>
														<div className="student-name break-word">
															{row?.first_name} {row?.last_name}
														</div>
														<div className="student-age-font " style={{ width: '90px' }}>
															{generateAgeString(row.date_of_birth)}
														</div>
													</div>
												</div>
											</TableCell>
											<TableCell>
												<div className="flex items-center parent-column">
													<Avatar className="mr-6" src={row?.contacts[0]?.thumb} />
													<div className="flex-col ">
														<div className="parent-name break-word">
															{row?.contacts[0]?.first_name} {row?.contacts[0]?.last_name}
														</div>
														<div className="parent-relation">{row?.contacts[0]?.relation_with_child}</div>
													</div>
												</div>
											</TableCell>
											<TableCell>
												<div className="items-center school-name-std">{row?.school?.name}</div>
											</TableCell>
											<TableCell>
												<div className="flex-col">
													<div className="contact-email break-word">
														{row?.contacts[0]?.email}
													</div>
													<div className="contact-phone">{row?.contacts[0]?.phone}</div>
												</div>
											</TableCell>
											<TableCell>
												<div className={row.status ? 'active-label' : 'disable-label'}>
													{row.status ? 'Active' : 'Inactive'}
												</div>
											</TableCell>
											<TableCell>
												<div className="flex-col">
													<div className="enroll-date">{moment.utc(row?.created_at).local().format('L')}</div>
													<div className="student-enroll-date">{moment.utc(row?.created_at).local().format('LT')}</div>
												</div>
											</TableCell>
										</TableRow>
									);
								})
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows?.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
}
